import { TENANT_DISPLAY_NAME } from '@/utils/constants';

export function getTenantDisplayName(name: string): string {
  return TENANT_DISPLAY_NAME[name] || name;
}

interface ResolveTenantDisplayNameParams {
  tenantSlug?: string | null;
  authMethod?: 'password' | 'sso' | null;
  tenants?: Array<{ slug: string; name: string }> | null;
  organizations?: Array<{ name: string; display_name: string }> | null;
}

/** Resolve the label for the active tenant from the URL slug. */
export function resolveTenantDisplayName({
  tenantSlug,
  authMethod,
  tenants,
  organizations,
}: ResolveTenantDisplayNameParams): string {
  if (!tenantSlug) {
    return '';
  }

  if (authMethod === 'sso' && organizations) {
    const org = organizations.find((o) => o.name === tenantSlug);
    if (org?.display_name) {
      return getTenantDisplayName(org.display_name);
    }
  }

  const tenant = tenants?.find((t) => t.slug === tenantSlug);
  if (tenant?.name) {
    return getTenantDisplayName(tenant.name);
  }

  return getTenantDisplayName(tenantSlug);
}
